export default "__VITE_ASSET__CKdj1tSC__"